/**
 * Каталог палитр.
 *
 * Все значения ниже — дизайн-токены этого приложения. Это не чужие фирменные
 * спецификации и не результат какой-либо сертификации считывания.
 *
 * Роли цветов разделены намеренно: qrBackground почти всегда белый,
 * независимо от того, какого цвета остальная карточка.
 */
export type Palette = {
  id: string;
  name: string;
  /** Фон всей карточки (может быть градиентом через backgroundGradient). */
  background: string;
  backgroundGradient?: [string, string];
  /** Фон непосредственно под QR и его защитным полем. */
  qrBackground: string;
  /** Цвет тёмных модулей QR. */
  qrForeground: string;
  /** Цвет подписи и заголовка. */
  text: string;
  /** Акцент: полосы, плашки. */
  accent: string;
  /** Цвет рамки карточки. */
  border: string;
  /** Откуда взяты значения: показывается пользователю. */
  origin: string;
};

export const PALETTES: Palette[] = [
  {
    id: 'mono',
    name: 'Монохром',
    background: '#FFFFFF',
    qrBackground: '#FFFFFF',
    qrForeground: '#111827',
    text: '#111827',
    accent: '#6B7280',
    border: '#111827',
    origin: 'Токены приложения',
  },
  {
    id: 'sea',
    name: 'Морской',
    background: '#F0F9FF',
    qrBackground: '#FFFFFF',
    qrForeground: '#123A63',
    text: '#123A63',
    accent: '#38BDF8',
    border: '#123A63',
    origin: 'Токены приложения',
  },
  {
    id: 'emerald',
    name: 'Изумрудный',
    background: '#F0FDF4',
    qrBackground: '#FFFFFF',
    qrForeground: '#14532D',
    text: '#14532D',
    accent: '#86EFAC',
    border: '#14532D',
    origin: 'Токены приложения',
  },
  {
    id: 'bordeaux',
    name: 'Бордовый',
    background: '#FFF7F7',
    qrBackground: '#FFFFFF',
    qrForeground: '#7F1D1D',
    text: '#7F1D1D',
    accent: '#FCA5A5',
    border: '#7F1D1D',
    origin: 'Токены приложения',
  },
  {
    id: 'indigo',
    name: 'Индиго',
    background: '#F5F3FF',
    qrBackground: '#FFFFFF',
    qrForeground: '#312E81',
    text: '#312E81',
    accent: '#A5B4FC',
    border: '#312E81',
    origin: 'Токены приложения',
  },
  {
    id: 'warm',
    name: 'Тёплый нейтральный',
    background: '#FAF7F2',
    qrBackground: '#FFFFFF',
    qrForeground: '#292524',
    text: '#292524',
    accent: '#A8A29E',
    border: '#292524',
    origin: 'Токены приложения',
  },
  {
    id: 'kurlyk',
    name: 'Курлык',
    background: '#F4F5F7',
    qrBackground: '#FFFFFF',
    qrForeground: '#2B3442',
    text: '#2B3442',
    accent: '#FF7F4D',
    border: '#2B3442',
    origin: 'Фирменные цвета этого сервиса',
  },
  {
    id: 'blue-red',
    name: 'Сине-красный',
    background: '#FFFFFF',
    qrBackground: '#FFFFFF',
    qrForeground: '#2E4894',
    text: '#2E4894',
    accent: '#ED1C24',
    border: '#2E4894',
    origin:
      'Ориентировочная веб-палитра. Не является официальной фирменной спецификацией какой-либо организации.',
  },
  {
    id: 'night-gradient',
    name: 'Ночной градиент',
    background: '#1E3A8A',
    backgroundGradient: ['#1E3A8A', '#6D28D9'],
    qrBackground: '#FFFFFF',
    qrForeground: '#1E1B4B',
    text: '#FFFFFF',
    accent: '#C4B5FD',
    border: '#312E81',
    origin: 'Токены приложения',
  },
  {
    id: 'forest-gradient',
    name: 'Лесной градиент',
    background: '#064E3B',
    backgroundGradient: ['#064E3B', '#0F766E'],
    qrBackground: '#FFFFFF',
    qrForeground: '#053B2C',
    text: '#FFFFFF',
    accent: '#5EEAD4',
    border: '#0F766E',
    origin: 'Токены приложения',
  },
  {
    id: 'slate-gradient',
    name: 'Графитовый градиент',
    background: '#0F172A',
    backgroundGradient: ['#0F172A', '#334155'],
    qrBackground: '#FFFFFF',
    qrForeground: '#0F172A',
    text: '#FFFFFF',
    accent: '#94A3B8',
    border: '#334155',
    origin: 'Токены приложения',
  },
];

export const DEFAULT_PALETTE_ID = 'mono';

export function getPalette(id: string): Palette {
  return PALETTES.find((p) => p.id === id) ?? PALETTES[0]!;
}

export function isKnownPaletteId(id: string): boolean {
  return PALETTES.some((p) => p.id === id);
}
